import React, { Component } from 'react'

import classNames from './Checklist.css'
import Icon from './Icon'

export default class Checklist extends Component {
  renderItem = item => {
    const { value, onChange } = this.props
    const isChecked = value.indexOf(item.value) !== -1
    const onCheck = () => onChange(value.concat(item.value), item)
    const onUncheck = () => onChange(value.filter(i => i !== item.value), item)
    return (
      <li key={item.value}>
        <button
          type='button'
          className={isChecked ? classNames.itemChecked : classNames.item}
          onClick={isChecked ? onUncheck : onCheck}>
          <div style={{ flex: 1 }}>
            <div className={classNames.title}>
              {item.title}
            </div>
            <div className={classNames.subtitle}>
              {item.subtitle}
              {item.extra}
            </div>
          </div>
          <div className={isChecked ? classNames.checkboxChecked : classNames.checkbox}>
            {isChecked &&
              <Icon icon='tick' className={classNames.tick} size={16} />
            }
          </div>
        </button>
        {item.append}
      </li>
    )
  }
  render () {
    const { items } = this.props
    return (
      <ul className={classNames.list}>
        {items.map(this.renderItem)}
      </ul>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Checklist.js